import { render } from "./TheFooter.vue?vue&type=template&id=1f7211ee&scoped=true&bindings={}"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=1f7211ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f7211ee"

export default script